export default function DotsIcon({
  className = "",
  orientation = "vertical",
}: {
  className?: string;
  orientation?: "vertical" | "horizontal";
}) {
  return (
    <svg
      width={orientation === "horizontal" ? "19" : "5"}
      height={orientation === "horizontal" ? "5" : "19"}
      viewBox={orientation === "horizontal" ? "0 0 19 5" : "0 0 5 19"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {orientation === "vertical" ? (
        <>
          <circle cx="2.5" cy="2.5" r="2.5" fill="currentColor" />
          <circle cx="2.5" cy="9.5" r="2.5" fill="currentColor" />
          <circle cx="2.5" cy="16.5" r="2.5" fill="currentColor" />
        </>
      ) : (
        <>
          <circle cx="2.5" cy="2.5" r="2.5" fill="currentColor" />
          <circle cx="9.5" cy="2.5" r="2.5" fill="currentColor" />
          <circle cx="16.5" cy="2.5" r="2.5" fill="currentColor" />
        </>
      )}
    </svg>
  );
}
